import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { UserOutlined } from '@ant-design/icons';

// Shared blog post card — used on the homepage "Our Blog" section and on
// the /blog listing page, so both stay visually in sync.
const BlogCard = ({ post }) => {
  const [hovered, setHovered] = useState(false);

  const formatDate = (dateString) => {
    if (!dateString) return '';
    return new Date(dateString).toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric'
    });
  };

  const topic = Array.isArray(post.tags) && post.tags.length > 0 ? post.tags[0] : 'General';

  return (
    <div
      className="blogcard-root"
      style={{
        background: '#fff',
        borderRadius: '24px',
        padding: '14px',
        boxShadow: hovered ? '0 20px 45px rgba(0,0,0,0.12)' : '0 6px 20px rgba(0,0,0,0.06)',
        display: 'flex',
        flexDirection: 'column',
        transition: 'transform 0.3s ease, box-shadow 0.3s ease',
        transform: hovered ? 'translateY(-8px)' : 'translateY(0)'
      }}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      {/* Image */}
      <Link to={`/blog/${post.slug}`} style={{ display: 'block', borderRadius: '18px', overflow: 'hidden', height: '230px' }}>
        <img
          src={post.coverImage}
          alt={post.title}
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            transition: 'transform 0.5s ease',
            transform: hovered ? 'scale(1.06)' : 'scale(1)'
          }}
        />
      </Link>

      {/* Content */}
      <div style={{ padding: '20px 10px 10px' }}>
        <Link to={`/blog/${post.slug}`} style={{ textDecoration: 'none' }}>
          <h3 style={{
            fontSize: '21px',
            fontWeight: 700,
            color: '#1a202c',
            margin: 0,
            marginBottom: '10px',
            lineHeight: 1.3,
            textAlign: 'left'
          }}>
            {post.title}
          </h3>
        </Link>

        {post.excerpt && (
          <p style={{
            fontSize: '14px',
            color: '#718096',
            lineHeight: 1.6,
            margin: '0 0 20px',
            display: '-webkit-box',
            WebkitLineClamp: 2,
            WebkitBoxOrient: 'vertical',
            overflow: 'hidden',
            textAlign: 'left'
          }}>
            {post.excerpt}
          </p>
        )}
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px', margin: '0 0 16px' }}>
          <div style={{
            width: '40px',
            height: '40px',
            minWidth: '40px',
            borderRadius: '50%',
            overflow: 'hidden',
            backgroundColor: '#f0e5f5',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}>
            {post.authorImage ? (
              <img
                src={post.authorImage}
                alt={post.author || 'Author'}
                style={{ width: '100%', height: '100%', objectFit: 'cover' }}
              />
            ) : (
              <UserOutlined style={{ fontSize: '16px', color: '#470172' }} />
            )}
          </div>
          <p style={{ fontSize: '14px', color: '#999', margin: 0, fontWeight: 500, textAlign: 'left' }}>
            By {post.author || 'AID Team'}
          </p>
        </div>

        <style>{`
          @media (max-width: 400px) {
            .blogcard-footer {
              flex-direction: column !important;
              align-items: flex-start !important;
            }
            .blogcard-stats {
              gap: 14px !important;
            }
          }
        `}</style>
        <div className="blogcard-footer" style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: '14px',
          paddingTop: '16px',
          borderTop: '1px solid #f0f0f0'
        }}>
          <div className="blogcard-stats" style={{ display: 'flex', gap: '22px', flexWrap: 'wrap' }}>
            <div>
              <div style={{ fontSize: '14px', fontWeight: 700, color: '#1a202c' }}>{formatDate(post.publishedAt)}</div>
              <div style={{ fontSize: '12px', color: '#999' }}>Published</div>
            </div>
            <div>
              <div style={{ fontSize: '14px', fontWeight: 700, color: '#1a202c' }}>{post.views || 0}</div>
              <div style={{ fontSize: '12px', color: '#999' }}>Views</div>
            </div>
            <div>
              <div style={{ fontSize: '14px', fontWeight: 700, color: '#1a202c', textTransform: 'capitalize' }}>{topic}</div>
              <div style={{ fontSize: '12px', color: '#999' }}>Topic</div>
            </div>
          </div>
          <Link
            to={`/blog/${post.slug}`}
            style={{
              display: 'inline-block',
              borderRadius: '3px',
              backgroundColor: hovered ? '#081225' : '#672f89',
              color: '#fff',
              textDecoration: 'none',
              fontSize: '14px',
              lineHeight: '24px',
              padding: '8px 25px',
              whiteSpace: 'nowrap',
              transition: 'background-color 0.3s ease'
            }}
          >
            Read more
          </Link>
        </div>
      </div>
    </div>
  );
};

export default BlogCard;
